<button [class.confirm]="this.confirm"
  mat-button mat-raised-button color="primary"
  (click)="onClick()"> {{this.confirm ? labelConfirm: label}}</button>
